import { render, staticRenderFns } from "./BurnDeviceTaskList.vue?vue&type=template&id=81bd941e&scoped=true&"
import script from "./BurnDeviceTaskList.vue?vue&type=script&lang=ts&"
export * from "./BurnDeviceTaskList.vue?vue&type=script&lang=ts&"
import style0 from "./BurnDeviceTaskList.vue?vue&type=style&index=0&id=81bd941e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bd941e",
  null
  
)

export default component.exports